const forgotPasswordFormFields = {
  newPassword: '',
  confirmPassword: ''
};

export { forgotPasswordFormFields };
